/**
 * Adapter: delegates IOrgManagement port to services/orgManagementService singleton.
 */
import type { AuditStatus, EmployeeType, Vendor } from '../../../types';
import {
  orgManagementService,
  type OrgManagementService,
} from '../../../services/orgManagementService';
import type { IOrgManagement } from '../../domain/ports/IOrgManagement';

export class OrgManagementAdapter implements IOrgManagement {
  constructor(private readonly service: OrgManagementService = orgManagementService) {}

  updateSimulation(tickNumber: number): void {
    this.service.updateSimulation(tickNumber);
  }

  hireEmployee(type: EmployeeType, currentOrgSize = 0) {
    return this.service.hireEmployee(type, currentOrgSize);
  }

  onboardVendor(vendorData: Partial<Vendor>) {
    return this.service.onboardVendor(vendorData);
  }

  scheduleAudit(type: AuditStatus['type'], targetDate: number) {
    return this.service.scheduleAudit(type, targetDate);
  }

  getEmployees() {
    return this.service.getEmployees();
  }

  getVendors() {
    return this.service.getVendors();
  }

  getAudits() {
    return this.service.getAudits();
  }

  getChecklists() {
    return this.service.getChecklists();
  }

  getWorkflows() {
    return this.service.getWorkflows();
  }

  getActiveAudits() {
    return this.service.getActiveAudits();
  }
}